// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ad40150f","389":"633ef6ce","455":"88888af0","977":"83aac2ce"}[chunkId] + ".chunk.js";
};